var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stanza-id',{attrs:{"isRoot":false,"sid":+_vm.sid,"fid":+_vm.fid}})}
var staticRenderFns = []

export { render, staticRenderFns }